import React, { useEffect, useState } from 'react'

import { isEmpty } from 'lodash'

import ThirdPartyManagementStepperContext from 'contexts/ThirdPartyManagementStepperContext'

import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import { routes } from 'Routes'
import { history } from 'service'

const ThirdPartyManagementStepperProvider = ({
  children,
  isEdit = false,
  isShow = false,
  isPreAvaliation = false,
  companySupplier = null,
  refresh = () => {},
  activeStep,
  setActiveStep,
  fromCreate = false,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [lastActiveStep, setLastActiveStep] = useState(
    helpers.thirdPartyManegementPartners.getInitialLastActiveStep({
      isShow,
      isEdit,
      isPreAvaliation,
      fromCreate,
    }),
  )
  const [wantsToAdvanceStep, setWantsToAdvanceStep] = useState(false)
  const [wantsToReturnStep, setWantsToReturnStep] = useState(false)
  const [showButtons, setShowButtons] = useState(true)
  const [companySupplierId, setCompanySupplierId] = useState(
    companySupplier?.id,
  )

  const snackbar = useSnackbar()

  const audits = companySupplier?.companySupplierAudits || []
  const EVALUATION_STEP_INDEX = 1

  const isBlockedByMissingAudit = (targetStep) =>
    !isShow && targetStep > EVALUATION_STEP_INDEX && isEmpty(audits)

  const notifyMissingAudit = () =>
    snackbar.open({
      message: 'É necessário criar uma auditoria para avançar de etapa.',
      variant: 'error',
    })

  const handleAdvanceStep = () => {
    if (isShow) return handleNext()
    setWantsToAdvanceStep(true)
  }

  const handleReturnStep = () => setWantsToReturnStep(true)

  const resetAdvanceStep = () => setWantsToAdvanceStep(false)

  const resetReturnStep = () => setWantsToReturnStep(false)

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setWantsToReturnStep(false)

    if (activeStep === 0 && !isPreAvaliation)
      return history.push(routes.thirdPartyManagements.mySuppliers.all)

    if (activeStep === 0 && isPreAvaliation) {
      return history.push(routes.thirdPartyManagements.preAvaliations)
    }

    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const handleStep = (step) => {
    if (step > lastActiveStep) return

    if (isBlockedByMissingAudit(step)) return notifyMissingAudit()

    setActiveStep(step)
  }

  const isCompleted = (step) => lastActiveStep > step

  useEffect(() => {
    if (activeStep > lastActiveStep) setLastActiveStep(activeStep)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep])

  return (
    <ThirdPartyManagementStepperContext.Provider
      value={{
        activeStep,
        handleAdvanceStep,
        handleBack,
        handleNext,
        handleReturnStep,
        handleStep,
        isCompleted,
        isEdit,
        isShow,
        isPreAvaliation,
        fromCreate,
        isLoading,
        refresh,
        resetAdvanceStep,
        resetReturnStep,
        setActiveStep,
        setIsLoading,
        setShowButtons,
        setCompanySupplierId,
        showButtons,
        companySupplierId,
        companySupplier,
        wantsToAdvanceStep,
        wantsToReturnStep,
      }}
    >
      {children}
    </ThirdPartyManagementStepperContext.Provider>
  )
}

export default ThirdPartyManagementStepperProvider
